import { useEffect } from 'react';
import { useState } from 'react';
import axios from '../../../lib/axios';
import {
  ADMIN_ORDER_ASSIGN_ORDER_TO_RIDER,
  ADMIN_ORDER_UPDATE,
  ADMIN_ORDER_UPDATE_STATUS,
} from '../../../lib/endpoints/order';
import { OrderStatusEnum } from '../../../enums/orderStatus';
import { convertOrderStatusEnumToStatusCode } from '../../../utils/convertOrderStatusValue';
import { USER_RIDER_NEARBY } from '../../../lib/endpoints/rider';
import { useTranslation } from 'react-i18next';
interface Props {
  selectedData: any;
  onClose: VoidFunction;
  onRefetchData: any;
  orderStatus: OrderStatusEnum;
}

const useOrderDetailController = ({ selectedData, onClose, onRefetchData, orderStatus }: Props) => {
  // variables
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [loadingConfirmDialog, setLoadingConfirmDialog] = useState<boolean>(false);
  const [riderData, setRiderData] = useState([]);

  const [selectedRiderId, setSelectedRiderId] = useState<string>(null!);
  const [loadingRiderNearby, setLoadingRiderNearby] = useState<boolean>(false);
  const [openConfirmDeclineDialog, setOpenConfirmDeclineDialog] = useState<boolean>(false);
  const [loadingConfirmDeclineDialog, setLoadingConfirmDeclineDialog] = useState<boolean>(false);

  const [defaultElement, DefaultElementSet] = useState<number>(6);

  const { t } = useTranslation('global');

  // functions

  const handleOpenDeclineConfirmDialog = () => {
    setOpenConfirmDeclineDialog(true);
  };

  const handleCloseDeclineConfirmDialog = () => {
    setOpenConfirmDeclineDialog(false);
  };

  const handleOpenConfirmDialog = (id: string) => {
    setOpenConfirmDialog(true);
    setSelectedRiderId(id);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleShowMoreRider = () => {
    DefaultElementSet(defaultElement + defaultElement);
  };

  const handleFetchDataRider = async () => {
    try {
      setLoadingRiderNearby(true);
      const findLocation: any = {
        latitude: selectedData?.merchant?.location?.coordinates[1],
        longitude: selectedData?.merchant?.location?.coordinates[0],
        maxDistance: 5000,
      };
      const riderResponse = await axios.post(USER_RIDER_NEARBY, findLocation);
      setRiderData(riderResponse?.data?.data);
    } catch (err) {
    } finally {
      setLoadingRiderNearby(false);
    }
  };

  const handleAssignJobToRider = async () => {
    try {
      setLoadingConfirmDialog(true);

      await axios.post(
        ADMIN_ORDER_ASSIGN_ORDER_TO_RIDER +
          `?orderId=${selectedData?.id}&riderId=${selectedRiderId}`
      );

      await onRefetchData();
      onClose();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        window.alert('error: ' + getErrorMessage);
      } catch (err) {
        window.alert(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmDialog(false);
      setOpenConfirmDialog(false);
    }
  };

  const handleDeclineConfirmDialog = async (getDescription: string) => {
    try {
      setLoadingConfirmDeclineDialog(true);
      const inputOrderStatus: number = convertOrderStatusEnumToStatusCode(OrderStatusEnum.Failed);
      await axios.post(`${ADMIN_ORDER_UPDATE_STATUS}?orderId=${selectedData?.id}&status=${inputOrderStatus}&description=${getDescription}`);
      await onRefetchData();
      onClose();
    } catch (err) {
      window.alert('server error please try again');
    } finally {
      setLoadingConfirmDeclineDialog(false);
    }
  };

  const rowRiderUser = riderData?.slice(0, defaultElement);

  // useEffect
  const isAbleToManageOrder: boolean =
    selectedData?.status?.code ===
      convertOrderStatusEnumToStatusCode(OrderStatusEnum.CURRENT_ORDER) ||
    selectedData?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Pack) ||
    selectedData?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Ship) ||
    selectedData?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Shipping);

  useEffect(() => {
    handleFetchDataRider();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData]);

  console.log("selectedData ==", selectedData);
  
  // useEffect
  return {
    openConfirmDialog,
    loadingConfirmDialog,
    handleCloseConfirmDialog,
    handleOpenConfirmDialog,
    isAbleToManageOrder,
    riderData,
    handleAssignJobToRider,
    loadingRiderNearby,
    openConfirmDeclineDialog,
    handleCloseDeclineConfirmDialog,
    handleOpenDeclineConfirmDialog,
    handleDeclineConfirmDialog,
    loadingConfirmDeclineDialog,
    rowRiderUser,
    handleShowMoreRider,
  };
};
export default useOrderDetailController;
